import { Component } from '@angular/core';

import { HeaderBaseComponent } from '@vivela/xplat/features';

@Component({
  selector: 'vv-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
})
export class HeaderComponent extends HeaderBaseComponent {}
